var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('page-title',{staticClass:"pt-120 pb-90"},[(_vm.obCourse.id)?[_c('b-col',{attrs:{"xs":"12"}},[_c('course-view',{attrs:{"item":_vm.obCourse}})],1)]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }